var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "document"
  }, "Document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "document"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v48h23c7.2,0,13-5.8,13-13V0H0z M34,35c0,6.1-4.9,11-11,11H2V2h32V35z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 14,
    width: 16,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 22,
    width: 16,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 30,
    width: 12,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.2352cd44f50338b917ffe6af4efb551d.svg";
export { ForwardRef as ReactComponent };